import type { ObjectId, SpatialObject } from '@/types';
import { useWorkspaceStore } from '@/store/workspaceStore';

/** Subscribes a component to exactly one object; unrelated edits do not re-render it. */
export const useObject = (id: ObjectId): SpatialObject | undefined =>
  useWorkspaceStore((s) => s.workspaces[s.activeWorkspaceId]?.objects[id]);
